  
import {useState,useEffect} from 'react';
import {auth,db} from '.././dashboard/firebase/firebase';
import {addDoc, collection,getDocs,query} from 'firebase/firestore';
import {initializeApp} from 'firebase/app'
import { signInWithPopup, GoogleAuthProvider } from "firebase/auth";
import queryString from 'query-string';
import {useNavigate} from 'react-router-dom';
import { de_encrypt, encrypt } from '../../encryption';
const Main =()=>{
  const navigate = useNavigate();
  const url= queryString.parse(window.location.search);
  const admin =['owoadeanuoluwapo2@gmail.com','ogbonnaemmanuel494@gmail.com','Psalmsheg@gmail.com','aowoade749@stu.ui.edu.ng'];
  const [lin,setLin]=useState(false);
  if(url.admin != undefined){
     if(!(admin.includes(de_encrypt(url.admin)))){
       navigate('/admin/admin');
      }
  }else{
    navigate('/admin/admin');
   }

  const [pack,setPackage]=useState(null);
  const [used,setUsed]=useState(null);
  const [unused, setUnUsed]=useState(null);
  const  [all_coupon_code, setAllCode]=useState(null);
  const [code,setCode]=useState('');
  const [res,setRes]=useState(null)
  const all_unused=[];
  const all_used=[];
  const all_codes=[]
  const get_coupon_key=(type)=>{
    var key;
    switch(type){
      case "starter":
        key = "STAR";
        break;
      case "premium":
        key = "PREM";
        break; 
      case "premium pro":
        key = "PREMP";
        break;   
      case "elite":
        key = "ELIT";
        break;
      case "expert":
        key = "EXPE";
        break; 
      case "worker":
        key = "WORK";
        break;  
    }
    return key;
  }
  const generate= async ()=>{
    if(pack != null){
       const coupon_data = {
                       code:`${get_coupon_key(pack)}_${Date.now()}`,
                       package_type:pack,
                       time: Date.now()
                    }
       const docRef = await addDoc(collection(db, "coupon"), coupon_data);
       setUnUsed(null);
//        window.location.reload()
     }else{
       alert('Select a valid package type')
     }   
  }
  const queryCode = ()=>{
    
    if(code != null){
        const used_res = used.filter((each)=>{return each.coupon === code})
        if(used.map((each)=>(each.coupon)).includes(code)){
           setRes(`The current user of this code is ${used_res[0].email}`)
           
        }
        else if(unused.filter((each)=>{return each.code == code}).length != 0){
           setRes('This code is unused')
        }
        else{
           setRes('This code does not exist')
        }

    }
  }
  useEffect(()=>{
       if(used==null){
            (async () => {
                const q = query(collection(db, "user"));
                const querySnapshot = await getDocs(q);
                querySnapshot.forEach((doc) => {
                   all_used.push(doc.data())
                });
                 setUsed(all_used.sort((a,b)=>{return b.time - a.time}));
//               setNotifications(all_not.sort((a,b)=>{return b.time - a.time}))
            })();
            
      } 
//      return ()=>{ 
//       setUsed('unmounted')
//      }   
    },[used])
   useEffect(()=>{
      if(all_coupon_code==null){
            (async () => {
                const q = query(collection(db, "coupon"));
                const querySnapshot = await getDocs(q);
                querySnapshot.forEach((doc) => {
                   all_codes.push(doc.data())
                });
                 setAllCode(all_codes.sort((a,b)=>{return b.time - a.time}));
            })();
            
      } 
//        return ()=>{
//          setAllCode('unmounted')
//        }   
    },[all_coupon_code])
    useEffect(()=>{
      
          if(all_coupon_code != null && used != null){
             all_coupon_code.forEach(code=>{
          if (used.map((each)=>(each.coupon)).includes(code.code)==false) all_unused.push(code) 
         })
        setUnUsed(all_unused.sort((a,b)=>{return b.time - a.time}));
        }
       
      
//        return ()=>{
//          setUnUsed('unmounted')
//        }  
    },[all_coupon_code,used])

  return (
    <div className="admin-container">
     <a href={`/admin/process/?admin=${url.admin}`}>View pending withdrawals </a>
     <a href={`/admin/ads/?admin=${url.admin}`}>Post ads </a>
      
     <div className="main-admin">
      <h2>Generate Coupon code</h2>
      <select onChange={(e)=>{setPackage(e.target.value)}}>
        <option value="null">Select package</option>
        <option value="starter">Starter</option>
        <option value="premium">premium</option>
        <option value="premium pro">Premium pro</option>
        <option value="elite">Elite</option>
        <option value="expert">Expert</option>
        <option value="worker">Worker</option>
      </select>
      <button onClick={generate}>Generate</button>
          <h3> Query coupon code</h3>
          {  used &&  <div className="box">
               <input value={code} onChange={(e)=>{setCode(e.target.value)}} />
               <button onClick={queryCode}>Search</button>
               <p style={{transform:"translateY(2em)"}}> <strong>Result</strong>: {res}</p>
           </div>
           
         }
         <h3 style={{display: "block", marginTop:"5em"}}>Unused Coupon Codes </h3>

         {  unused &&  <div className="box">
          {
           unused.map(each=>(
           <div>
             <p>{each.code}</p> 
           </div>
           
           ))
           }
          
        
        </div> }
          
        <h3>Used Coupon Codes </h3>

         {  used &&  <div className="box">
           <p>Number of users:<strong> {used.length}</strong></p>
          {
           used.map(each=>(
           <div>
             <p>{each.coupon}</p> 
           </div>
           
           ))
         }
           </div>}
         <h3>All Coupon Codes </h3>

         {  all_coupon_code &&  <div className="box">
          {
           all_coupon_code.map(each=>(
           <div>
             <p>{each.code}</p> 
           </div>
           
           ))
           }
          
        
        </div> }

      
       
    
    </div> 
    
    </div>
  )
}
export default Main
